import { render, staticRenderFns } from "./HolidayEditForm.vue?vue&type=template&id=2e551318&scoped=true&"
import script from "./HolidayEditForm.vue?vue&type=script&lang=js&"
export * from "./HolidayEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e551318",
  null
  
)

export default component.exports